import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.page.html',
  styleUrls: ['./landing.page.scss']
})
export class LandingPage {
  constructor(private router: Router, private auth: AuthService) {}

  goToConvert(): void {
    if (this.auth.token) {
      this.router.navigateByUrl('/app/home');
    } else {
      this.router.navigateByUrl('/auth/login');
    }
  }
}
